import { ImageBlockFallbackCard } from './components/image-block-fallback.js';
import { ImageBlockPageComponent } from './components/page-image-block.js';
import { ImageBlockComponent } from './image-block.js';
import { ImageEdgelessBlockComponent } from './image-edgeless-block.js';
import { ImageEdgelessPlaceholderBlockComponent } from './preview-image/edgeless.js';
import { ImagePlaceholderBlockComponent } from './preview-image/page.js';

export function effects() {
  customElements.define('hive-image', ImageBlockComponent);
  customElements.define('hive-edgeless-image', ImageEdgelessBlockComponent);
  customElements.define('hive-page-image', ImageBlockPageComponent);
  customElements.define('hive-image-fallback-card', ImageBlockFallbackCard);
  customElements.define(
    'hive-placeholder-preview-image',
    ImagePlaceholderBlockComponent
  );
  customElements.define(
    'hive-edgeless-placeholder-preview-image',
    ImageEdgelessPlaceholderBlockComponent
  );
}
